import { render, staticRenderFns } from "./searchRequirement.vue?vue&type=template&id=4b237594&"
import script from "./searchRequirement.vue?vue&type=script&lang=ts&"
export * from "./searchRequirement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports